module.exports = __webpack_public_path__ + "static/media/0224_IMG_LES_MURS_CHROMATIC_CH2_1039.b8bf352e.png";